import React from "react";

const SamplePrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className="text-white hover:text-gray-300 transition-colors duration-200 cursor-pointer z-10 absolute top-1/2 left-2 -translate-y-1/2 p-2 border-2 border-white rounded-full bg-black flex justify-center items-center"
      onClick={onClick}
    >
      <span className="text-3xl font-bold">{'<'}</span>
    </div>
  );
};

export default SamplePrevArrow;
